import { gql } from '@apollo/client';

export const CREATE_USER = gql`
  mutation CreateUser($request: CreateUserRequest!) {
    CreateUser(request: $request) {
      id
    }
  }
`;

export const UPDATE_USER_PASSWORD = gql`
  mutation ChangePassword($request: ChangePasswordRequest!) {
    ChangePassword(request: $request) {
      id
    }
  }
`;

export const UPDATE_USERS = gql`
  mutation UpdateUser($id: String!, $request: UpdateUserRequest!) {
    UpdateUser(id: $id, request: $request) {
      id
      name
      email
      note
    }
  }
`;

export const UPDATE_USER_FOR_USER = gql`
  mutation UpdateUserForUser(
    $id: String!
    $request: UpdateUserForUserRequest!
  ) {
    UpdateUserForUser(id: $id, request: $request) {
      id
      name
      email
      note
      phone_number
      profile_pic_document_id
    }
  }
`;

export const CHANGE_USER_ACTIVATION = gql`
  mutation ChangeUserActivation($id: String!, $request: ActivationRequest!) {
    ChangeUserActivation(id: $id, request: $request) {
      id
      active_status
    }
  }
`;

export const CHANGE_USER_ROLE = gql`
  mutation UpdateUserRole($request: UpdateUserRoleRequest!) {
    UpdateUserRole(request: $request) {
      id
    }
  }
`;
